import { useState } from 'react';
var usePagination = function (totalItems, itemsPerPage) {
    var _a = useState(0), currentPage = _a[0], setCurrentPage = _a[1];
    var totalPages = itemsPerPage > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;
    var goToNextPage = function () {
        setCurrentPage(function (prevPage) { return (prevPage + 1) % totalPages; });
    };
    var goToPreviousPage = function () {
        setCurrentPage(function (prevPage) { return (prevPage - 1 + totalPages) % totalPages; });
    };
    return { currentPage: currentPage, totalPages: totalPages, goToNextPage: goToNextPage, goToPreviousPage: goToPreviousPage };
};
export default usePagination;
